var helper = require('../../helper');
require('moment');

var PropertyViewingCalendarOfPropertyController = function(datatable) {

    this.datatable = datatable;
    this.propertyId = $('#js-property-id').data('property');
    this.calendar = $('#property-viewings-calendar-property');
    this.$modal = $('#edit-property-viewing-of-property');
    this.$updateButton = this.$modal.find('.modal-submit-button');
    this.$deleteButton = this.$modal.find('.js-modal-delete-button');

    this.EditModalFormController = new (require('../../services/modals/ModalFormController'))(this.$modal);
    this.PropertyViewingCalendarController = new (require('../../modules/property_viewings/PropertyViewingCalendarController'))();

    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

    (function()

    {

        self.$updateButton.click(function(e){
            self.updateModel(e);
        });

        self.$deleteButton.click(function(e){
            self.deleteModel(e);
        });

    }());


}

PropertyViewingCalendarOfPropertyController.prototype.render = function(message, title) {

    var self = this;

    this.calendar.fullCalendar('destroy');

    this.calendar.fullCalendar({
        events: helper.getOrigin() + "/api/property_viewings/property/" + this.propertyId,
        header: {
            left: '',
            center: 'prev title next',
            right: 'listWeek,month,agendaWeek,agendaDay'
        },
        defaultView: 'agendaWeek',
        timeFormat: 'HH:mm',
        axisFormat: 'HH:mm',
        firstHour: 9,
        firstDay: 1,
        minTime: '07:00',
        displayEventEnd: true,
        editable: false,
        droppable: false,
        dropAccept: '#external-events div.external-event',

        eventClick: function (event) {

            var  fields = ['id', 'user_id', 'confirmed', 'attendees', 'rooms_taken', 'day', 'time_from', 'time_to', 'notes', 'updated_at'];

            self.getModel(event.id, function(model){

                self.EditModalFormController.loadData(model, fields) // my modal

                self.EditModalFormController.showModal(); // on CALLBACK!
            });

        }
    });

    self.datatable.reload();
}

PropertyViewingCalendarOfPropertyController.prototype.deleteModel = function(e) {

    var msg = 'Are you sure you want to delete this?';

    if (!confirm(msg)) {
        e.preventDefault();
        return;
    }

    e.preventDefault();

    this.PropertyViewingCalendarController.deleteModel(this, this.EditModalFormController);
}

PropertyViewingCalendarOfPropertyController.prototype.updateModel = function(e) {
    e.preventDefault();
    this.PropertyViewingCalendarController.updateModel(this, this.EditModalFormController);
}

PropertyViewingCalendarOfPropertyController.prototype.getModel = function(modelId, callbackSuccess) {
    return this.PropertyViewingCalendarController.getModel(modelId, callbackSuccess);
}

PropertyViewingCalendarOfPropertyController.prototype.getFormData = function(unindexed_array) {
    return this.PropertyViewingCalendarController.getFormData(unindexed_array);
}

PropertyViewingCalendarOfPropertyController.prototype.clearModal = function() {
    this.EditModalFormController.clearModal();
}

PropertyViewingCalendarOfPropertyController.prototype.showModal = function() {
    this.EditModalFormController.showModal();
}

PropertyViewingCalendarOfPropertyController.prototype.closeModal = function() {
    this.EditModalFormController.closeModal();
}

module.exports = PropertyViewingCalendarOfPropertyController;